<template>
	<div @click.prevent="$emit('back-button-click')" class="back-button" :class="[theme, position]">
		<svg class="arrow-icon" width="10" height="17" viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M8.5 15L2 8.5L8.5 2" stroke="#6A6D82" stroke-width="2.4" stroke-linecap="round"/>
		</svg>

		Back
	</div>
</template>

<script>
const CLOSE_POSITIONS = ['left', 'right']
const CLOSE_THEMES = ['dark', 'light', 'dark-invert', 'white', 'white-invert']

export default {
    name: 'SimplePaywallBackButton',
	props: {
		theme: {
			type: String,
			default: 'primary',
			validator: (val) => CLOSE_THEMES.includes(val)
		},
		position: {
			type: String,
			default: 'right',
			validator: (val) => CLOSE_POSITIONS.includes(val)
		}
	},
	emits: ['back-button-click']
}
</script>

<style lang="scss" scoped>
.back-button {
	cursor: pointer;
	position: absolute;
	display: flex;
	align-items: center;
	top: 15px;
	left: 13px;
	color: #6A6D82;

	.arrow-icon {
		margin-right: 8px;
	}

	&.dark,.dark-invert {
		color: #fff;

		.arrow-icon path {
			stroke: #fff
		}
	}
}
</style>
